import { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../components/Layout";
import { useParams } from "react-router-dom";
import CreatureCard from "../components/CreatureCard";

const Author = () => {
  const [authorData, setAuthorData] = useState(false);
  let { authorid } = useParams(); // Unpacking and retrieve id

  useEffect(() => {
    getAuthor();
  }, []);

  const getAuthor = () => {
    axios
      .get(
        `https://creatureparty.net/dashboard/wp-json/creatureparty/v1/authors/${authorid}`
      )
      .then((res) => setAuthorData(res.data))
      .catch((err) => console.log(err));
  };

  return (
    <Layout>
      <section className="Author">
        {authorData ? (
          <div>
            <div className="Author__Title">
              <h1>{authorData.info.firstName} has invited ...</h1>
              
                {authorData.info.website ? (
                  <a className="Author__Link" href={authorData.info.website} target="_blank">
                    {authorData.info.firstName} has a website! »
                  </a>
                ) : (
                  null
                )}
              
              <p></p>
            </div>

            <div className="Author__Creatures">
              {authorData.creatures.map((creature, i) => {
                return (
                    <CreatureCard key={`creature${i}`} data={creature} />
                );
              })}
            </div>
          </div>
        ) : null}
      </section>
    </Layout>
  );
};

export default Author;
